import { Story } from '../../DocTypes';

export const dataDrivenPillsStory: Story = {
  title: 'Data driven pills',
  description: 'List with items that contain pills driven by data',
  coreComponent: {
    html: `<tag-list
    primary-field='name'
    pill-1-field='rating'
    pill-1-field-accent-field='ratingAccent'
    pill-2-field='club'>
  </tag-list>`,
    js: `var tagList = document.querySelector('tag-list');
  tagList.componentOnReady().then(function() {
    tagList.setData([
      { name: 'Harry Maguire', rating: '10', ratingAccent: 'atoll', club: 'Man United' },
      { name: 'Luke Shaw', rating: '8', ratingAccent: 'gulfstream', club: 'Man United' },
      { name: 'Mason Mount', rating: '2', ratingAccent: 'mojo', club: 'Man United' },
      { name: 'Jude Bellingham', rating: '7', ratingAccent: 'gulfstream', club: 'Spurs'  },
    ]);
  });
    `,
  },
  // coreComponent_v3: {
  //   html: `<tag3-list
  //   primary-field='name'
  //   pill-1-field='rating'
  //   pill-1-field-accent-field='ratingAccent'
  //   pill-2-field='club'>
  // </tag3-list>`,
  //   js: `var tagList = document.querySelector('tag3-list');

  //   tagList.setData([
  //     { name: 'Harry Maguire', rating: '10', ratingAccent: 'atoll', club: 'Man United' },
  //     { name: 'Luke Shaw', rating: '8', ratingAccent: 'gulfstream', club: 'Man United' },
  //     { name: 'Mason Mount', rating: '2', ratingAccent: 'mojo', club: 'Man United' },
  //     { name: 'Dele Alli', rating: '7', ratingAccent: 'gulfstream', club: 'Spurs'  },
  //   ]);

  //   `,
  // },
  reactWrapper: {
    jsx: `<TagList
    primaryField='name'
    pill1Field='rating'
    pill1FieldAccentField='ratingAccent'
    pill2Field='club'
    data={[
      { name: 'Harry Maguire', rating: '10', ratingAccent: 'atoll', club: 'Man United' },
      { name: 'Luke Shaw', rating: '8', ratingAccent: 'gulfstream', club: 'Man United' },
      { name: 'Mason Mount', rating: '2', ratingAccent: 'mojo', club: 'Man United' },
      { name: 'Jude Bellingham', rating: '7', ratingAccent: 'gulfstream', club: 'Spurs'  },
    ]}
  />`,
  },
};
